export default {
    path: '*',
    redirect: { path: '/' },
}